// @flow

import * as React from "react";
import classNames from "classnames";
import "./landing-card.style.scss";

type Props = $Exact<{
  className?: string,
  onClick?: Function,
  onIconClick?: Function,
  image: string | React$Node,
  color: string,
  title: string | React$Node | null,
  description?: string | React$Node,
  buttons?: React.Node,
  buttonsClassName?: string,
  bottom?: React.Node,
  disabled?: boolean,
  centered?: boolean,
  hidden?: boolean,
  inactive?: boolean,
  role?: string,
  t?: (textKey: string, params?: Array<string> | {}, comment?: string) => string,
}>;

class LandingCard extends React.Component<Props> {
  static defaultProps = {
    disabled: false,
    onClick: () => null,
    color: "primary",
  };

  onClick = (): void => {
    if (this.props.disabled !== true && this.props.onClick) {
      this.props.onClick();
    }
  };

  onIconClick = (): void => {
    if (this.props.disabled !== true && this.props.onIconClick) {
      this.props.onIconClick();
    }
  };

  render() {
    return !this.props.hidden ? (
      <div
        className={classNames("landing-card", this.props.className, {
          disabled: this.props.disabled,
          inactive: this.props.inactive,
        })}
        onClick={this.onClick}
        role={this.props.role}
      >
        <div
          className={classNames("landing-card__icon", {
            "align-items-center": this.props.centered,
            [`${this.props.color} bg`]: !this.props.disabled && !this.props.inactive,
            "bg-disabled inactive": this.props.inactive,
            "m-0 mb-5": !this.props.title,
          })}
          onClick={this.onIconClick}
        >
          {this.props.inactive ? (
            <div className="landing-card__inactive-text">
              {this.props.t ? this.props.t("DISABLED_DOT_TEXT") : ""}
            </div>
          ) : (
            this.props.image
          )}
          {this.props.title && (
            <div
              className={classNames("my-2 h3 landing-card-title", {
                [this.props.color]: !this.props.disabled,
                "text-disabled-light": this.props.disabled || this.props.inactive,
                "text-center": this.props.centered,
              })}
            >
              {this.props.title}
            </div>
          )}
        </div>
        {!this.props.inactive && (
          <div className="landing-card__title">
            {this.props.description && (
              <div
                className={classNames("text-secondary", {
                  "text-disabled-light": this.props.disabled,
                })}
              >
                {this.props.description}
              </div>
            )}
            {this.props.buttons && (
              <div
                className={classNames("mt-4", this.props.buttonsClassName, {
                  "text-center": this.props.centered,
                })}
              >
                {this.props.buttons}
              </div>
            )}
            {this.props.bottom && <div className="landing-card__bottom">{this.props.bottom}</div>}
          </div>
        )}
      </div>
    ) : null;
  }
}

export default LandingCard;
